export default "__VITE_ASSET__CdAktj1e__"